<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="760px"
    title="设置推送范围"
    class="send-range-data-dialog "
    :mask-closable="false"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    @cancel="TipDialogVisible=false"
    @ok="formHandle"
  >
    <!-- <div class="webhook-tip-d-t">
      <a-alert
        message="设置推送数据所属的团队/小组/人员范围，系统将推送所选范围的数据通知"
        type="info"
        show-icon
      />
    </div> -->
    <div class="alert-blue-title">
      设置推送数据所属的团队/小组/人员范围，系统将推送所选范围的数据通知
    </div>
    <div class="content clearfix">
      <div class="left fl">
        <h3>可选范围</h3>
        <div
          v-if="currentRangeDatas.length"
          class="result scroll_bar_beautify_ff"
        >
          <a-tree
            v-if="currentRangeDatas.length"
            ref="treeList"
            checkable
            :default-expanded-keys="checkedKeys"
            :tree-data="currentRangeDatas"
            :checked-keys="checkedKeys"
            :show-checked-strategy="true"
            @check="onCheck"
          />
        </div>
      </div>
      <span class="border" />
      <div class="right fl">
        <h3>已选推送范围</h3>
        <draggable
          v-model="checkedDatas"
          :options="{
            animation: 60,
            handle:'.dray-item'
          }"
          class="result scroll_bar_beautify_ff"
          @end="dragEndHandle"
        >
          <transition-group>
            <div
              v-for="(item, i) in checkedDatas"
              :key="i"
              class="item clearfix"
              :class="{ 'active': item.active}"
            >
              <div class="dray-item fl">
                <i class="iconfont iconicon-test72 move-icon" />
                <span>{{ item.name }}</span>
              </div>
              <i
                class="iconfont iconicon-test5 fr close-icon"
                @click="onDeleteItem(item, i)"
              />
            </div>
          </transition-group>
        </draggable>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  props: {
    datas: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false,
      checkedKeys: [],
      checkedDatas: []
    }
  },
  computed: {
    ...mapGetters('config/webhook', ['currentRangeDatas']),
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    modalTit () {
      return this.$t('message["1037"]')
    }
  },
  watch: {
    // 监听树形数据选中数据，设置右边选中元素集合
    checkedKeys (val) {
      this.checkedDatas = []
      val.forEach(item => {
        this.FilterCheckedKeys(this.checkedDatas, item, val, this.currentRangeDatas)
      })
    },
    TipDialogVisible (val) {
      if (val) {
        this.checkedDatas = this.datas
        this.getCheckedKeys()
      }
    }
  },
  methods: {
    ...mapMutations('config/webhook', ['setSendRangeCheckedData']),
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    formHandle () {
      const { checkedDatas } = this
      const formData = checkedDatas.map(item => {
        const itemObj = {}
        itemObj['name'] = item.name
        if (item.groupname) {
          itemObj['groupname'] = item.groupname
        }

        if (item.key.indexOf('|') > -1) {
          const arr = item.key.split('|')
          arr.forEach(item2 => {
            const arrItem2 = item2.split('-')
            itemObj[arrItem2[0]] = arrItem2[1]
          })
        } else {
          if (item.key.indexOf('-') > -1) {
            const arrItem = item.key.split('-')
            itemObj[arrItem[0]] = arrItem[1]
          }
        }
        return itemObj
      })
      this.setSendRangeCheckedData(formData)
      this.$emit('getRangeH')
      this.TipDialogVisible = false
    },
    onCheck (val, info) {
      this.checkedKeys = val
    },
    // 递归过滤已选中父元素的子元素
    FilterCheckedKeys (arr, i, checkedKeys, data) {
      data.forEach(item => {
        const isHasChildren = item.children && item.children.length
        if (item.key === i && !checkedKeys.includes(item.pid)) {
          arr.push({ key: item.key, name: item.title })
        } else {
          if (isHasChildren) {
            this.FilterCheckedKeys(arr, i, checkedKeys, item.children)
          }
        }
      })
    },
    // 删除后数据处理
    onDeleteItem (item, i) {
      this.checkedDatas.splice(i, 1)
      this.getCheckedKeys()
    },
    // 拖拽后数据处理
    dragEndHandle () {
      this.getCheckedKeys()
    },

    // 获取树形结构选中值方法
    getCheckedKeys () {
      this.checkedKeys = []
      this.checkedDatas.forEach(item => {
        this.checkedKeysLoop(this.checkedKeys, item.key, this.currentRangeDatas)
      })
    },

    // 获取树形结构选中值递归
    checkedKeysLoop (arr, key, treeDatas) {
      treeDatas.forEach(item => {
        const isHasChildren = item.children && item.children.length
        if (item.key === key) {
          arr.push(item.key)
          if (isHasChildren) {
            item.children.forEach(item2 => {
              arr.push(item2.key)
              if (item2.children && item2.children.length) {
                item2.children.forEach(item3 => {
                  arr.push(item3.key)
                })
              }
            })
          }
        } else {
          if (isHasChildren) {
            this.checkedKeysLoop(arr, key, item.children)
          }
        }
      })
    }

  }
}
</script>
<style lang="scss">
.send-range-data-dialog {
  .ant-modal {
    padding-bottom: 0;
  }
  .ant-modal-body {
    padding: 16px 40px;
  }
  .ant-tree li span.ant-tree-switcher {
    color: #ccc;
  }
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_open
    .ant-tree-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_open
    .ant-select-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_close
    .ant-tree-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_close
    .ant-select-switcher-icon {
    font-size: 24px;
    color: #d8d8d8;
  }
  .ant-tree > li {
    > .ant-tree-node-content-wrapper {
      .ant-tree-title {
        font-weight: bold;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
// .webhook-tip-d-t::v-deep {
//     // margin: -16px 0 16px;
//     margin-bottom: 24px;
//     .ant-alert-info{
//       border-color:#4CA0F2 ;
//       background: #DBEDFF;
//     }
//   }
.alert-blue-title {
  background-color: #e8f4ff;
  color: #333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding-left: 24px;
  margin: -16px -40px 32px;

}
.content {
  position: relative;
  h3 {
    height: 48px;
    line-height: 48px;
    font-weight: bold;
  }
  .left {
    width: 320px;
    margin-right: 40px;
    .result {
      max-height: 524px;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  .border {
    position: absolute;
    left: 320px;
    top: 0;
    width: 0;
    height: 100%;
    border-right: solid 1px $gray4;
  }
  .right {
    width: 320px;
    .result {
      max-height: 524px;
      overflow-x: hidden;
      overflow-y: auto;
    }
    .item {
      overflow: hidden;
      height: 32px;
      line-height: 32px;
      padding: 0 12px;
      &:hover {
        background-color: #f4f7f9;
        .iconfont.move-icon {
          opacity: 1;
        }
      }
    }
    .dray-item {
      cursor: move;
    }
    .iconfont.move-icon {
      opacity: 0;
      margin-right: 4px;
      color: #ccc;
    }
    .iconfont.close-icon {
      margin-right: 20px;
      cursor: pointer;
      color: #d6d6d6;
    }
  }
}
.footer {
  text-align: right;
}
</style>
